/**
 * GHG-specific re-export of the shared organization ID hook.
 *
 * New code should import `useOrganizationId` from `@/hooks/use-organization-id`
 * directly. This re-export exists for backwards compatibility with existing
 * GHG code that imports `useGHGOrganizationId`.
 */

import { useOrganizationId } from '@/hooks/use-organization-id';

export function useGHGOrganizationId(): string | undefined {
  return useOrganizationId();
}
